import React, { useState } from "react";
import "./signup.css";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import {
    getAuth,
    createUserWithEmailAndPassword,
    sendEmailVerification,
} from "firebase/auth";
import { getDatabase, ref, set } from "firebase/database";
import { app } from "../firebase";
import image2 from "./img3.jpg";
import logoLight from "../../logo1.png";
import logoDark from "../../white1.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const auth = getAuth(app);
const db = getDatabase(app);

const RegistrationForm = ({ isDarkMode }) => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
    });

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const togglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword((prevShowConfirmPassword) => !prevShowConfirmPassword);
    };

    const createuser = async () => {
        // Check if the email matches the pattern
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            setErrorMessage("Please enter a valid email address");
            return;
        }

        if (password.length < 8) {
            setErrorMessage("Password must be at least 8 characters long");
            return;
        }

        if (formData.confirmPassword !== password) {
            setErrorMessage("Passwords do not match!");
            return;
        }

        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            const userId = user.uid;
            const userRef = ref(db, `users/${userId}`);
            await set(userRef, {
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: email,
                createdAt: Date.now(), // Add creation timestamp
            });

            // Send email verification
            await sendEmailVerification(auth.currentUser);

            console.log("User registered successfully:", user);
            setErrorMessage("Verification email sent. Please verify your email address to proceed.");
        } catch (error) {
            console.error("Error registering user:", error.message);
            let errorMessage = "An error occurred. Please try again later.";

            if (error.code === "auth/email-already-in-use") {
                errorMessage = "This email is already in use. Please use a different email address.";
            } else if (error.code === "auth/invalid-email") {
                errorMessage = "Invalid email address. Please provide a valid email address.";
            } else if (error.code === "auth/weak-password") {
                errorMessage = "Password is too weak. Please choose a stronger password.";
            }
            setErrorMessage(errorMessage);
        }
    };

    const closeErrorMessage = () => {
        setErrorMessage(""); // Clear the error message
    };

    const backgroundStyle = {
        backgroundImage: `url(${image2})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        width: "100%",
        // backgroundColor: "rgba(255, 255, 255, 0.8)",
    };

    return (
        <div style={backgroundStyle}>
            <div className={`formContainerStyle {${isDarkMode ? 'dark-mode' : 'light-mode'}rounded`} style={{ backgroundColor: isDarkMode ? '#333' : '#f8f9fa', width: "100%", maxWidth: "347px", marginRight: "-5%", padding: "20px" }} >
                <div className="text-center mb-4">
                    {isDarkMode ? (
                        <img src={logoDark} alt="Dark Mode Logo" className="logo" style={{ width: "170px", height: "auto", marginRight: "13%" }} />
                    ) : (
                        <img src={logoLight} alt="Light Mode Logo" className="logo1" style={{ width: "170px", height: "auto", marginRight: "13%" }} />
                    )}
                </div>
                <h6 style={{ color: isDarkMode ? '#fff' : '#000', textAlign:"center", fontWeight: "bold", fontFamily: "cursive", marginTop:"-19%" ,fontSize:"0.55rem",marginLeft:"24%"  }}>Discover Scholarships & Opportunities</h6>
                <h2 className="title text-center" style={{ marginLeft: "1%",marginTop:"5%" }}>Register</h2>
                {errorMessage && (
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        {errorMessage}
                        <button type="button" className="btn-close" onClick={closeErrorMessage} aria-label="Close" style={{ outline: "none" }}></button>
                    </div>
                )}

                <form className="form d-flex flex-column align-items-center" onSubmit={(e) => e.preventDefault()} style={{ maxWidth: "400px", width: "100%", height: "auto" }}>
                    <div className="form-group row align-items-center mb-0">
                        <label htmlFor="firstName" className="form-label col-sm-3" style={{ color: isDarkMode ? '#ffffff' : '#000000' }}>
                            Firstname
                        </label>
                        <div className="input-group col-sm-9">
                            <input
                                className={`form-control ${isDarkMode ? '' : 'placeholder-color'}`}
                                type="text"
                                name="firstName"
                                placeholder="Write Your First Name"
                                value={formData.firstName}
                                onChange={handleInputChange}
                                required
                                style={{
                                    height: "40px", // Reduced height
                                    padding: "6px 12px", // Reduced padding
                                    width: "97%", // Full width
                                    backgroundColor: isDarkMode ? '#f8f9fa' : '#333',
                                    color: isDarkMode ? '#000' : '#fff',
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-group row align-items-center">
                        <label htmlFor="lastName" className="form-label col-sm-3" style={{ color: isDarkMode ? '#ffffff' : '#000000' }}>
                            Lastname
                        </label>
                        <div className="input-group col-sm-9">
                            <input
                                className={`form-control ${isDarkMode ? '' : 'placeholder-color'}`}
                                type="text"
                                name="lastName"
                                placeholder="Write Your Last Name"
                                value={formData.lastName}
                                onChange={handleInputChange}
                                required
                                style={{
                                    height: "40px", // Reduced height
                                    padding: "6px 12px", // Reduced padding
                                    width: "97%", // Full width
                                    backgroundColor: isDarkMode ? '#f8f9fa' : '#333',
                                    color: isDarkMode ? '#000' : '#fff',
                                }}
                            />
                        </div>
                    </div>

                    <div className="form-group row align-items-center" style={{ width: "109%" }}>
                        <label htmlFor="email" className="form-label col-sm-3" style={{ color: isDarkMode ? '#ffffff' : '#000000' }}>
                            Email
                        </label>
                        <div className="input-group col-md-12">
                            <input
                                onChange={(e) => setEmail(e.target.value)}
                                className={`form-control ${isDarkMode ? '' : 'placeholder-color'}`}
                                type="email"
                                required
                                name="email"
                                placeholder="Write Your Email Address"
                                value={email}
                                style={{
                                    height: "40px", // Reduced height
                                    padding: "6px 12px", // Reduced padding
                                    // width: "100%", // Full width
                                    backgroundColor: isDarkMode ? '#f8f9fa' : '#333',
                                    color: isDarkMode ? '#000' : '#fff',
                                }}
                            />
                        </div>
                    </div>

                    <div className="form-group row align-items-center">
                        <label htmlFor="password" className="form-label col-sm-3" style={{ color: isDarkMode ? '#ffffff' : '#000000' }}>
                            Password
                        </label>
                        <div className="input-group col-sm-9">
                            <input
                                onChange={(e) => setPassword(e.target.value)}
                                className={`form-control ${isDarkMode ? '' : 'placeholder-color'}`}
                                type={showPassword ? "text" : "password"}
                                required
                                name="password"
                                placeholder="Write Your Password"
                                value={password}
                                style={{
                                    height: "40px", // Reduced height
                                    padding: "6px 12px", // Reduced padding
                                    width: "88%", // Adjusted width to accommodate button
                                    backgroundColor: isDarkMode ? '#f8f9fa' : '#333',
                                    color: isDarkMode ? '#000' : '#fff',
                                }}
                            />
                            <button
                                className="btn btn-outline-secondary btn-sm p-1"
                                type="button"
                                onClick={togglePasswordVisibility}
                            >
                                {showPassword ? <FaEyeSlash size={14} /> : <FaEye size={14} />}
                            </button>
                        </div>
                    </div>

                    <div className="form-group row align-items-center " style={{}} >
                        <label htmlFor="confirmPassword" className="form-label col-sm-3 " style={{ display: "ruby", color: isDarkMode ? '#ffffff' : '#000000' }}>
                            Confirm Password
                        </label>
                        <div className="input-group col-sm-9">
                            <input
                                className={`form-control ${isDarkMode ? '' : 'placeholder-color'}`}
                                type={showConfirmPassword ? "text" : "password"}
                                name="confirmPassword"
                                placeholder="Write Your Confirm Password"
                                value={formData.confirmPassword}
                                onChange={handleInputChange}
                                required
                                style={{
                                    display: "inline-block",
                                    height: "40px", // Reduced height
                                    padding: "6px 12px", // Reduced padding
                                    width: "88%", // Adjusted width to accommodate button
                                    backgroundColor: isDarkMode ? '#f8f9fa' : '#333',
                                    color: isDarkMode ? '#000' : '#fff',
                                }}
                            />
                            <button
                                className="btn btn-outline-secondary btn-sm p-1"
                                type="button"
                                onClick={toggleConfirmPasswordVisibility}
                            >
                                {showConfirmPassword ? <FaEyeSlash size={14} /> : <FaEye size={14} />}
                            </button>
                        </div>
                    </div>

                    <button className="btn btn-secondary" type="button" onClick={createuser} style={{
                        backgroundColor: isDarkMode ? '#f8f9fa' : '#333',
                        color: isDarkMode ? '#000' : '#fff', marginTop: "8%"
                    }}>
                        Submit
                    </button>
                </form>

                <p className="signup text-center mt-3" style={{color: isDarkMode ? '#fff' : '#000'}}>
                    Already Have Account?
                    <Link to="/login">
                        <span className="fw-bold " style={{color: isDarkMode ? '#fff' : '#000'}}> Login</span>
                    </Link>
                </p>
            </div>
        </div>
    );
};
export default RegistrationForm;
